//@flow
export const FETCH_LIST_REQUESTED = "statusUpdateViews/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "statusUpdateViews/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "statusUpdateViews/FETCH_LIST_FAILED";

export const RESET_LIST = "statusUpdateViews/RESET_LIST";
